<template>
    <div class="container">
        <div class="modal" v-show="loading">
            <div class="modal-dialog-centered">
                <div class="modal-content">
                    <vue-loading type="spin" :size="{ width: '50px', height: '50px'}"></vue-loading>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8 pl-0 form-group">
                <label for="store" class="bmd-label-floating">店舗</label>
                <select id="store" class="form-control" v-model="selected">
                    <option value=""></option>
                    <option v-for="condition in conditions" :key="condition.condition_id" :value="condition.condition_id">
                        {{ condition.store_name }}
                    </option>
                </select>
            </div>
            <div class="col-4 pr-o form-group">
                <button v-on:click="reload" type="button" class="btn btn-outline-primary" id="btn-reload">
                    店舗一覧更新
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-8 pl-0">
                <b-alert
                    :variant="variant"
                    :show="count"
                    @dismissed="count=0"
                    @dismiss-count-down="function (value) { if (value < Number.MAX_SAFE_INTEGER - 1) count = value; }"
                    fade
                >
                    {{ message }}
                </b-alert>
            </div>
            <div class="col-4 pr-0 text-right" id="div-save">
                <button v-if="condition" @click="submit" type="button" class="btn btn-outline-primary">保存する</button>
            </div>
        </div>
        <div v-if="condition" class="row">
            <tabs :options="{ useUrlFragment: false }">
                <tab name="変更時刻">
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start">変更時刻</label>
                        <select v-model="hour" class="form-control col-2 col-md-1" dir="rtl">
                            <option value="-1"></option>
                            <option v-for="(text, value) in hours()" :value="value" v-text="text"></option>
                        </select>
                        <label class="bmd-label pl-2 pr-2">:</label>
                        <select v-model="minute" class="form-control col-2 col-md-1">
                            <option value="-1"></option>
                            <option v-for="(text, value) in minutes()" :value="value" v-text="text"></option>
                        </select>
                    </div>
                    <div class="row form-group">
                        <label class="bmd-label col-3 justify-content-start">最終変更日時</label>
                        <label class="bmd-label col-9">{{ condition.executed_at_label }}</label>
                    </div>
                    <div v-if="condition.failed_at" class="row form-group">
                        <label class="bmd-label col-3 justify-content-start">エラー発生日時</label>
                        <label class="bmd-label col-9">{{ condition.failed_at_label }}</label>
                    </div>
                    <div v-if="condition.failed_message" class="row form-group">
                        <label class="bmd-label col-3 justify-content-start">エラーメッセージ</label>
                        <label class="bmd-label col-9 break-all">{{ condition.failed_message }}</label>
                    </div>
                </tab>
                <tab name="ポイント条件">
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start">ポイントを使用する</label>
                        <div class="col-6 col-sm-8 col-lg-6 pl-0 pr-0">
                            <segmented-control
                                v-model="condition.point_use_division"
                                :segments="[ { value: '1', label: '使用する' }, { value: '0', label: '使用しない' } ]"
                            />
                        </div>
                    </div>
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start">ポイント付与(基準)</label>
                        <input
                            class="form-control text-right col-2"
                            v-model="condition.point_giving_unit_price"
                            id="point-giving-unit-price"
                            type="text"
                            pattern="^[1-9][0-9]{0,4}$"
                            required
                        />
                        <label class="bmd-label">円毎に、</label>
                        <input
                            class="form-control text-right col-2"
                            v-model="condition.point_giving_unit"
                            id="point-giving-unit"
                            type="text"
                            pattern="^(0|[1-9][0-9]{0,4})(.[0-9]{1,2})?$"
                            required
                        />
                        <label class="bmd-label">ポイントをつける</label>
                    </div>
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start">利用ポイント</label>
                        <label class="bmd-label">1ポイント</label>
                        <input
                            class="form-control text-right col-2"
                            v-model="condition.point_spend_rate"
                            id="point-spend-rate"
                            type="text"
                            pattern="^(0|100|[1-9][0-9]{0,1})$"
                            required
                        />
                        <label class="bmd-label">円相当とする</label>
                    </div>
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start"></label>
                        <label class="bmd-label">(</label>
                        <input
                            class="form-control text-right col-2"
                            v-model="condition.point_spend_unit"
                            id="point-spend-unit"
                            type="text"
                            pattern="^[1-9][0-9]{0,4}$"
                            required
                        />
                        <label class="bmd-label">ポイント単位で利用可能)</label>
                    </div>
                    <div class="row form-group form-inline">
                        <label class="bmd-label col-3 justify-content-start">付与ポイント計算</label>
                        <div class="col-9">
                            <div class="form-check-inline">
                                <input type="radio" class="form-check-input" v-model="condition.point_giving_division" value="1"/>
                                <label class="bmd-label form-check-label">税額を含める + 利用ポイント分を含める</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="radio" class="form-check-input" v-model="condition.point_giving_division" value="2"/>
                                <label class="bmd-label form-check-label">税額を含めない + 利用ポイント分を含める</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="radio" class="form-check-input" v-model="condition.point_giving_division" value="3"/>
                                <label class="bmd-label form-check-label">税額を含める + 利用ポイント分を含めない</label>
                            </div>
                            <div class="form-check-inline">
                                <input type="radio" class="form-check-input" v-model="condition.point_giving_division" value="4"/>
                                <label class="bmd-label form-check-label">税額を含めない + 利用ポイント分を含めない</label>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab name="週設定">
                    <div class="row form-inline" id="day-of-weeks">
                        <div class="form-group form-inline justify-content-end col-4 col-md-3 pr-1" v-for="day_of_week in day_of_weeks">
                            <label :for="day_of_week.id " class="bmd-label">{{ day_of_week.label }}</label>
                            <input :id="day_of_week.id" class="form-control text-right col-6" v-model="day_of_week.multiplier" type="number"/>
                            <label :for="day_of_week.id" class="bmd-label">倍</label>
                        </div>
                    </div>
                </tab>
                <tab name="月設定">
                    <div class="row form-inline" id="day-of-months">
                        <div class="form-group form-inline justify-content-end col-4 col-md-3 pr-1" v-for="day_of_month in day_of_months">
                            <label :for="day_of_month.id" class="bmd-label">{{ day_of_month.label }}</label>
                            <input :id="day_of_month.id" class="form-control text-right col-6" v-model="day_of_month.multiplier" type="number"/>
                            <label :for="day_of_month.id" class="bmd-label">倍</label>
                        </div>
                    </div>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                conditions: [],
                condition: null,
                hour: -1,
                minute: -1,
                message: null,
                variant: 'danger',
                count: 0,
                loading: true,
            }
        },
        mounted() {
            this.load();
        },
        computed: {
            selected: {
                get () {
                    return this.condition ? this.condition.condition_id : '';
                },
                set (value) {
                    this.condition = this.conditions.find(function (condition) {
                        return value === condition.condition_id;
                    });
                    let matches = this.condition?.executing_at?.match(/([0-9]{2}):([0-9]{2})/);
                    if (matches) {
                        this.hour = parseInt(matches[1]);
                        this.minute = parseInt(matches[2]);
                    } else {
                        this.hour = -1;
                        this.minute = -1;
                    }
                },
            },
            day_of_weeks: {
                get() {
                    return this.condition.day_of_weeks.sort(function (a, b) {
                        return a.day < b.day ? -1 : a.day > b.day ? 1 : 0;
                    });
                },
            },
            day_of_months: {
                get () {
                    return this.condition.day_of_months.sort(function (a, b) {
                        return a.day < b.day ? -1 : a.day > b.day ? 1 : 0;
                    });
                },
            },
        },
        watch: {
            hour() {
                if (!this.condition) return;
                if (this.hour >= 0 && this.minute >= 0) {
                    this.condition.executing_at = this.hour.toString().padStart(2, '0') + ':' + this.minute.toString().padStart(2, '0');
                } else {
                    this.condition.executing_at = null;
                }
            },
            minute() {
                if (!this.condition) return;
                if (this.hour >= 0 && this.minute >= 0) {
                    this.condition.executing_at = this.hour.toString().padStart(2, '0') + ':' + this.minute.toString().padStart(2, '0');
                } else {
                    this.condition.executing_at = null;
                }
            }
        },
        methods: {
            load(reload = false, page = 1) {
                let vm = this;
                vm.loading = true;
                vm.count = 0;
                let url = new URL('/conditions', window.location.toString());
                if (reload) {
                    url.searchParams.append('reload', 'true');
                }
                url.searchParams.append('page', page.toString());
                axios.get(url.href).then(function (response) {
                    if (response.data.conditions) {
                        vm.conditions = response.data.conditions;
                        let index = vm.conditions.findIndex(function (condition) {
                            return vm.condition && vm.condition.condition_id === condition.condition_id;
                        });
                        if (index === -1) {
                            vm.condition = null;
                        } else {
                            vm.condition = vm.conditions[index];
                        }
                        vm.loading = false;
                    } else {
                        vm.load(true, page + 1);
                    }
                }).catch(function (error) {
                    vm.show(error.response?.data?.message ?? 'データの取得に失敗しました。');
                    vm.loading = false;
                });
            },
            reload() {
                this.load(true);
            },
            submit() {
                if (!this.condition) return;
                if (!$('#point-giving-unit-price')[0].checkValidity()) {
                    this.show('ポイント付与は1円～99999円で入力してください。');
                    return;
                }
                if (!$('#point-giving-unit')[0].checkValidity()) {
                    this.show('ポイント付与は0.00ポイント～99999.99ポイントで入力してください。');
                    return;
                }
                if (!$('#point-spend-rate')[0].checkValidity()) {
                    this.show('利用ポイントは0円～100円で入力してください。');
                    return;
                }
                if (!$('#point-spend-unit')[0].checkValidity()) {
                    this.show('利用ポイントは1ポイント～99999ポイントで入力してください。');
                    return;
                }
                {
                    let element = $('#day-of-weeks input').filter(function () {
                        return !Number.isInteger(Number.parseFloat(this.value)) || this.value < 0 || this.value > 9999999;
                    }).first();
                    if (element[0]) {
                        let dayOfWeek = this.condition.day_of_weeks[Number.parseInt(element.attr('id').replace(/day-of-week-/, '')) - 1];
                        this.show('週設定>' + dayOfWeek.label + 'の倍率は0以上9999999以下の整数で入力してください。');
                        return;
                    }
                }
                {
                    let element = $('#day-of-months input').filter(function () {
                        return !Number.isInteger(Number.parseFloat(this.value)) || this.value < 0 || this.value > 9999999;
                    }).first();
                    if (element[0]) {
                        let dayOfWeek = this.condition.day_of_months[Number.parseInt(element.attr('id').replace(/day-of-month-/, '')) - 1];
                        this.show('月設定>' + dayOfWeek.label + 'の倍率は0以上9999999以下の整数で入力してください。');
                        return;
                    }
                }
                let vm = this;
                vm.loading = true;
                vm.count = 0;
                axios.patch('/conditions/'+vm.condition.condition_id, {
                    'condition': vm.condition,
                }).then(function (response) {
                    vm.show(response.data, 'success');
                }).catch(function (error) {
                    vm.show(error.response?.data?.message ?? 'データの保存に失敗しました。');
                }).finally(function () {
                    vm.loading = false;
                });
            },
            hours() {
                let hours = {};
                for (let hour = 0; hour < 24; hour++) {
                    hours[hour] = hour.toString().padStart(2, '0');
                }
                return hours;
            },
            minutes() {
                let minutes = {};
                for (let minute = 0; minute < 60; minute+=5) {
                    minutes[minute] = minute.toString().padStart(2, '0');
                }
                return minutes;
            },
            show(message, variant='danger') {
                this.variant = variant;
                this.count = variant === 'danger' ? Number.MAX_SAFE_INTEGER : 3;
                this.message = message;
            },
        },
    }
</script>

<style>
    .modal {
        display: block;
    }
    .modal-content {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        display: flex;
        background-color: transparent;
    }
    .alert {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }
    #btn-reload {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-bottom: 0;
    }
    #div-save {
        padding: 0.843750rem 0;
    }
    #div-save button {
        margin-bottom: 0;
    }
</style>
